import axios, { CancelToken } from 'axios';

export const axiosSource = () => CancelToken.source();


